module.exports = __webpack_public_path__ + "static/media/YF36_2.57bbabfd.jpg";